(function () {

  // ── CONFIGURACIÓN ────────────────────────────────────────────────────────
  const WS_BASE = "https://jelpcloud.com/WS/03/appClientes/";
  const ID_PAIS_MX = 1;

  // ── FLAG GLOBAL: true = muestra pregunta de material, false = toma servicios[0][0] directo
  const _MOSTRAR_PREGUNTAS_GLOBAL = false;

  // ── VARIABLES GLOBALES ───────────────────────────────────────────────────
  let _productoActual         = null;
  let _idServicioSeleccionado = null;
  let _materialSeleccionado   = null;
  let _desaparecerMensajeConfirmacion = false;

  // ── INICIO ───────────────────────────────────────────────────────────────
  document.addEventListener('DOMContentLoaded', function () {

    const _wrapper = document.getElementById('service-installer');
    if (!_wrapper) return;

    const _idArticulo   = _wrapper.dataset.idArticulo;
    const _productTitle = _wrapper.dataset.productTitle;

    // Primero buscamos el producto en el catálogo
    // Si no existe, ocultamos todo el widget
    _productoActual = buscarProducto(_idArticulo);
    if (!_productoActual) {
      _wrapper.style.display = 'none';
      return;
    }

    // ── LISTENER DEL CHECKBOX ─────────────────────────────────────────────
    document.getElementById('si-checkbox-instalacion').addEventListener('change', function () {

      const _contenido = document.getElementById('si-contenido');

      if (this.checked) {

        // Muestra el contenido
        _contenido.style.display = 'block';
        iniciarFlujo(_idArticulo);

      } else {

        // Oculta todo y limpia el estado
        _contenido.style.display        = 'none';

        // Reinicia los steps
        document.getElementById('si-step-preguntas').style.display = 'none';
        document.getElementById('si-step-cp').style.display        = 'none';
        document.getElementById('si-step-confirmar').style.display = 'none';
        document.getElementById('si-preguntas-container').innerHTML = '';
        document.getElementById('si-cp-input').value               = '';
        document.getElementById('si-cp-mensaje').style.display     = 'none';
        document.getElementById('si-exito-msg').innerHTML          = '';

        // Limpia variables globales
        _idServicioSeleccionado = null;
        _materialSeleccionado   = null;

        // Deshabilita y limpia los inputs ocultos (properties del carrito)
        const _hiddenServicio = document.getElementById('si-hidden-id-servicio');
        const _hiddenArticulo = document.getElementById('si-hidden-id-articulo');
        const _hiddenMaterial = document.getElementById('si-hidden-material');

        _hiddenServicio.value    = '';
        _hiddenServicio.disabled = true;
        _hiddenArticulo.value    = '';
        _hiddenArticulo.disabled = true;
        _hiddenMaterial.value    = '';
        _hiddenMaterial.disabled = true;
      }
    });

    // ── BOTÓN BUSCAR CP ───────────────────────────────────────────────────
    document.getElementById('si-btn-buscar').addEventListener('click', async function () {

      if (!_idServicioSeleccionado) {
        mostrarMensajeCP('Primero selecciona el material de tu puerta.', 'error');
        return;
      }

      const _cp = document.getElementById('si-cp-input').value.trim();

      if (!_cp || _cp.length < 4) {
        mostrarMensajeCP('Ingresa un código postal válido.', 'error');
        return;
      }

      this.textContent = 'Buscando...';
      this.disabled    = true;

      try {

        const _params = new URLSearchParams({
          ws_serv:       'revisaAgendaDisponibilidadRegional',
          id_servicio:   _idServicioSeleccionado,
          id_pais:       ID_PAIS_MX,
          id_estado:     1,
          codigo_postal: _cp,
          id_ciudad:     1,
        });

        const _response = await fetch(WS_BASE, {
          method:  'POST',
          headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
          body:    _params.toString(),
        });

        if (!_response.ok) throw new Error('HTTP error: ' + _response.status);

        const _result = await _response.json();

        if (_result.error && _result.error > 0) {
          _desaparecerMensajeConfirmacion = true;
          mostrarMensajeCP('Sin cobertura en tu código postal.', 'error');
          this.textContent = 'Buscar';
          this.disabled    = false;
        } else if (!_result.data || !Array.isArray(_result.data) || _result.data.length === 0) {
          // data vacío, null o array vacío = sin cobertura
          _desaparecerMensajeConfirmacion = true;
          mostrarMensajeCP('Sin cobertura en tu código postal.', 'error');
          this.textContent = 'Buscar';
          this.disabled    = false;
        } else {
          _desaparecerMensajeConfirmacion = false;
          mostrarMensajeCP('Cobertura disponible en tu zona.', 'ok');
          this.textContent = 'Buscar';
          this.disabled    = false;
          mostrarBotonFinal();
        }

      } catch (_err) {
        mostrarMensajeCP('Error al conectar. Intenta de nuevo. ' + _err, 'error');
        this.textContent = '🔍 Buscar';
        this.disabled    = false;
      }
    });

  });

  // ── INICIAR FLUJO: busca producto y decide si muestra preguntas ───────────

  function iniciarFlujo(_idArticulo) {

    const _mostrar = _MOSTRAR_PREGUNTAS_GLOBAL && _productoActual.mostrar_preguntas;

    if (_mostrar) {
      document.getElementById('si-step-preguntas').style.display = 'block';
      renderPreguntaMaterial(_productoActual);
    } else {
      _idServicioSeleccionado = _productoActual.servicios[0][0];
      document.getElementById('si-step-cp').style.display = 'block';
    }
  }

  // ── BUSCAR PRODUCTO EN CATÁLOGO LOCAL ────────────────────────────────────
  function buscarProducto(_idArticulo) {
    if (!window._CONFIG_SERVICIOS) return null;
    return window._CONFIG_SERVICIOS.find(function (_p) {
      return _p.id_articulo === parseInt(_idArticulo);
    }) || null;
  }

  // ── RENDERIZAR PREGUNTA DE MATERIAL ──────────────────────────────────────
  function renderPreguntaMaterial(_producto) {

    // Catálogo de materiales con su posición en el subarray servicios[0]
    const _MATERIALES = [
      { label: 'Madera',                    posicion: 0 },
      { label: 'Aluminio (perfil europeo)', posicion: 1 },
      { label: 'Cristal',                   posicion: 2 },
      { label: 'Metal (no aluminio)',        posicion: 3 },
    ];

    // Filtra solo los que tienen id_servicio válido (no 0 ni undefined)
    const _opcionesValidas = _MATERIALES.filter(function (_m) {
      return (_producto.servicios[0][_m.posicion] || 0) > 0;
    });

    const _contenedor     = document.getElementById('si-preguntas-container');
    _contenedor.innerHTML = '';

    const _bloque     = document.createElement('div');
    _bloque.className = 'si-pregunta-bloque';

    const _espeshorHtml = _producto.espesor
      ? '<p class="si-espesor">Espesor compatible: <strong>' + _producto.espesor + '</strong></p>'
      : '';

    const _opcionesHtml = _opcionesValidas.map(function (_op) {
      return '<button type="button" class="si-opcion-material"'
           + ' data-posicion="' + _op.posicion + '"'
           + ' data-label="'   + _op.label    + '">'
           + _op.label
           + '</button>';
    }).join('');

    _bloque.innerHTML = '<p class="si-pregunta-texto">De que material es la puerta?</p>'
      + _espeshorHtml
      + '<div class="si-opciones-material">' + _opcionesHtml + '</div>';

    _contenedor.appendChild(_bloque);

    // Al elegir material → guarda id_servicio y habilita la búsqueda de CP
    _bloque.querySelectorAll('.si-opcion-material').forEach(function (_btn) {
      _btn.addEventListener('click', function () {

        _bloque.querySelectorAll('.si-opcion-material').forEach(function (_b) {
          _b.classList.remove('si-opcion-activa');
        });
        this.classList.add('si-opcion-activa');

        _idServicioSeleccionado = _producto.servicios[0][parseInt(this.dataset.posicion)];
        _materialSeleccionado   = this.dataset.label;

        // Muestra el input de CP ahora que ya se eligió material
        document.getElementById('si-step-cp').style.display = 'block';
      });
    });
  }

  // ── MOSTRAR BOTÓN FINAL ───────────────────────────────────────────────────
  // ── COBERTURA CONFIRMADA: guarda datos y habilita el carrito ─────────────
  function mostrarBotonFinal() {

    const _step = document.getElementById('si-step-confirmar');
    if (_step.style.display === 'block') return;

    _step.style.display = 'block';
    _step.scrollIntoView({ behavior: 'smooth', block: 'nearest' });

    const _wrapper    = document.getElementById('service-installer');
    const _idArticulo = _wrapper.dataset.idArticulo;

    // Activa y llena los inputs ocultos para que Shopify los adjunte a la orden
    const _hiddenServicio  = document.getElementById('si-hidden-id-servicio');
    const _hiddenArticulo  = document.getElementById('si-hidden-id-articulo');
    const _hiddenMaterial  = document.getElementById('si-hidden-material');

    if (_hiddenServicio) {
      _hiddenServicio.value    = _idServicioSeleccionado;
      _hiddenServicio.disabled = false;
    }
    if (_hiddenArticulo) {
      _hiddenArticulo.value    = _idArticulo;
      _hiddenArticulo.disabled = false;
    }
    if (_hiddenMaterial) {
      _hiddenMaterial.value    = _materialSeleccionado || '';
      _hiddenMaterial.disabled = false;
    }

    // Mensaje de confirmación al usuario
    /*document.getElementById('si-exito-msg').innerHTML =
        '✅ Cobertura confirmada. '
      + (_materialSeleccionado ? 'Material: <strong>' + _materialSeleccionado + '</strong>. ' : '')
      + 'Ya puedes agregar el producto al carrito.';*/

    document.getElementById('si-exito-msg').innerHTML =
        'Un asesor te contactará para cotizar tu instalación.';

    console.log('id_servicio:', document.getElementById('si-hidden-id-servicio').value);
    console.log('id_articulo:', document.getElementById('si-hidden-id-articulo').value);
    console.log('material:',    document.getElementById('si-hidden-material').value);
    console.log('disabled:',    document.getElementById('si-hidden-id-servicio').disabled);
  }

  // ── UTILIDADES ───────────────────────────────────────────────────────────
  function mostrarMensajeCP(_texto, _tipo) {
    const _msg         = document.getElementById('si-cp-mensaje');
    _msg.style.display = 'block';
    _msg.textContent   = _texto;
    _msg.className     = _tipo === 'ok' ? 'si-mensaje-ok' : 'si-mensaje-error';


    const _step = document.getElementById('si-step-confirmar');
    
    if(_desaparecerMensajeConfirmacion){
      _step.style.display = 'none';
    }
  }

})();